import { createBrowserRouter, redirect } from 'react-router-dom'
import { Suspense } from 'react'
import { getMachineModel, getDeviceForSupport, ConnectionError } from '@/lib/supabase'
import RootLayout from '@/layouts/RootLayout'
import { PageLoader, SupportSkeleton } from '@/components/Loaders'

import { SupportPage, NotFoundPage, ImpressumPage, DatenschutzPage } from '@/pages/lazy'

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        index: true,
        loader: () => redirect('/404'),
      },
      {
        path: '/support/:id',
        loader: async ({ params }) => {
          const id = params.id!
          try {
            const device = await getDeviceForSupport(id)
            if (device) return device
            const model = await getMachineModel(id)
            if (model) return model
          } catch (e) {
            // Netzwerk-/Supabase-Fehler → eigene Fehlerseite mit „Erneut versuchen"
            if (e instanceof ConnectionError) throw e
            throw new ConnectionError(e instanceof Error ? e.message : 'unknown')
          }
          throw new Response('Not Found', { status: 404 })
        },
        element: (
          <Suspense fallback={<SupportSkeleton />}>
            <SupportPage />
          </Suspense>
        ),
        hydrateFallbackElement: <SupportSkeleton />,
        errorElement: (
          <Suspense fallback={<PageLoader />}>
            <NotFoundPage />
          </Suspense>
        ),
      },
      {
        path: '/impressum',
        element: (
          <Suspense fallback={<PageLoader />}>
            <ImpressumPage />
          </Suspense>
        ),
      },
      {
        path: '/datenschutz',
        element: (
          <Suspense fallback={<PageLoader />}>
            <DatenschutzPage />
          </Suspense>
        ),
      },
      {
        path: '/404',
        element: (
          <Suspense fallback={<PageLoader />}>
            <NotFoundPage />
          </Suspense>
        ),
      },
      ...(import.meta.env.DEV
        ? [{ path: '/dev/animationen', lazy: async () => ({ Component: (await import('@/pages/AnimationPreviewPage')).default }) }]
        : []),
      {
        path: '*',
        loader: () => redirect('/404'),
      },
    ],
  },
])
